<template>
  <a-row :gutter="16">
    <a-col :span="12">
      <a-form-item
        label="启用的视图类型"
        name="enable_view_types"
        extra="不选 = 全部启用"
      >
        <a-select
          v-model:value="model.enable_view_types"
          mode="multiple"
          allow-clear
          placeholder="不选 = 全部启用"
          :options="viewTypeOptions"
        />
      </a-form-item>
    </a-col>
    <a-col :span="12">
      <a-form-item
        label="默认视图类型"
        name="default_view_type"
        extra="仅能在已启用的视图类型中选择；未启用任何类型时不限"
      >
        <a-select
          v-model:value="model.default_view_type"
          allow-clear
          placeholder="默认标准视图"
          :options="defaultViewTypeOptions"
        />
      </a-form-item>
    </a-col>
    <a-col :span="12">
      <a-form-item label="启用分页">
        <a-switch
          v-model:checked="model.is_pagination"
          checked-children="开"
          un-checked-children="关"
        />
      </a-form-item>
    </a-col>
    <a-col :span="12">
      <a-form-item
        label="每页条数"
        name="pageSize"
      >
        <a-input-number
          v-model:value="model.pageSize"
          style="width: 100%"
          :min="1"
          placeholder="默认 200"
        />
      </a-form-item>
    </a-col>
    <a-col :span="12">
      <a-form-item
        label="每页条数选项"
        name="page_size_options"
      >
        <a-select
          v-model:value="model.page_size_options"
          mode="tags"
          :open="false"
          placeholder="如 10、20、50、100"
          :token-separators="[',', ' ']"
        />
      </a-form-item>
    </a-col>
  </a-row>
</template>

<script setup lang="ts">
import { computed, watch } from 'vue';
import { VIEW_TYPE_OPTIONS } from './constants';

/* ★ v29.35（用户定案）：`dbViewConfig.vue` 按步骤拆分——「展示配置」步（★ v29.45 起为 Step 2）。
   本步持有 view_meta 白名单里回传给前端的 5 个键（写在共享 model 上）。
   ★ v29.18：order_json 迁到列配置（DbViewColumn 默认排序三字段）、
   max_page_size / pivot_table_max_records 机制废除，原「查询行为」步骤移除。
   ★ v29.13：org_filter 已废除（组织过滤只靠 SQL 里手写 {{org_id}}），不再提供配置项。
   拆分约定同 Step 1：`model` 由外壳持有、对象引用共享，这里取 computed 后直接改属性。
   `view_meta` 的拆包/合并（applyViewMeta / buildViewMeta）已提为纯函数放 `./viewMeta.ts`。 */

interface Props {
  model: any;
}
const props = defineProps<Props>();

const model = computed(() => props.model);

const viewTypeOptions = VIEW_TYPE_OPTIONS;

/* ★ v29.18：default_view_type 仅能在 enable_view_types 勾选的值中选择；
   enable_view_types 为空 = 全部启用，default_view_type 不受限 */
const defaultViewTypeOptions = computed(() => {
  const enabled = model.value.enable_view_types;
  return Array.isArray(enabled) && enabled.length
    ? viewTypeOptions.filter(o => enabled.includes(o.value))
    : viewTypeOptions;
});

watch(
  () => model.value.enable_view_types,
  enabled => {
    if (
      Array.isArray(enabled) &&
      enabled.length &&
      model.value.default_view_type &&
      !enabled.includes(model.value.default_view_type)
    ) {
      model.value.default_view_type = undefined; // 启用范围变更后默认类型失效 → 清空
    }
  },
);
</script>
